import React, {ReactNode} from "react";
import {css} from "@emotion/react";

import {calculateRemSize, flex, flexDirection} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

interface IProps {
    iconSlot?: ReactNode;
    text: string;
}

export const FeedbackPopupHeader = (props: IProps) => {
    return (
        <div css={[flex("center"), flexDirection("row")]}>
            {props.iconSlot ? <div css={iconSlotWrapperStyle}>{props.iconSlot}</div> : null}
            <Text variant="headline_6" css={textSlotStyle}>
                {props.text}
            </Text>
        </div>
    );
};

const iconSlotWrapperStyle = css`
    flex: 0 0 auto;
    height: ${calculateRemSize(6)};
`;

const textSlotStyle = css`
    flex: 1 1 100%;
`;
import React, {ReactNode} from "react";
import {css} from "@emotion/react";

import {calculateRemSize, flex, flexDirection} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

interface IProps {
    iconSlot?: ReactNode;
    text: string;
}

export const FeedbackPopupHeader = (props: IProps) => {
    return (
        <div css={[flex("center"), flexDirection("row")]}>
            {props.iconSlot ? <div css={iconSlotWrapperStyle}>{props.iconSlot}</div> : null}
            <Text variant="headline_6" css={textSlotStyle}>
                {props.text}
            </Text>
        </div>
    );
};

const iconSlotWrapperStyle = css`
    flex: 0 0 auto;
    height: ${calculateRemSize(6)};
`;

const textSlotStyle = css`
    flex: 1 1 100%;
`;
